import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';
import './Pricing.css';

function Pricing() {
  return (
    <div className="pricing-container">
      <div className="pricing-header">
        <h1>Simple, Transparent Pricing</h1>
        <p>Choose the plan that best fits your needs</p>
      </div>

      <div className="pricing-grid">
        {/* Plan Test-it */}
        <div className="pricing-card">
          <div className="pricing-card-header">
            <h2>Test-it</h2>
            <div className="price">
              <span className="currency">$</span>
              <span className="amount">0</span>
              <span className="period">/trial period</span>
            </div>
            <p>Perfect for testing and evaluation</p>
          </div>
          <div className="pricing-features">
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Self-Hosted</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Send and receive text and media messages</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Webhooks</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Built-in Dashboard</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Whatsapp logs live view</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Unlimited messages</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>HTTP API access</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Single device connection</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Community support</span>
            </div>
          </div>
          <a href="https://docs.whinself.app/docs/tutorials/quick-start" className="pricing-button">Start Trial</a>
        </div>

        {/* Plan Premium */}
        <div className="pricing-card premium">
          <div className="pricing-card-header">
            <h2>Premium</h2>
            <div className="price">
              <span className="currency">$</span>
              <span className="amount">2.5</span>
              <span className="period">/month</span>
            </div>
            <p>For businesses and production use</p>
          </div>
          <div className="pricing-features">
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Self-Hosted</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Send and receive text and media messages</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Webhooks</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Built-in Dashboard</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Whatsapp logs live view</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Unlimited messages</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>HTTP API access</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Single device connection</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Priority support 24/7</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>Early access to new features</span>
            </div>
            <div className="feature">
              <CheckIcon className="feature-icon" />
              <span>and more!</span>
            </div>
          </div>
          <a href="https://docs.whinself.app/docs/tutorials/quick-start" className="pricing-button premium">Get Started</a>
        </div>
      </div>

      <div className="comparison-section">
        <h2>Why Choose Whinself?</h2>
        <div className="comparison-table">
          <table>
            <thead>
              <tr>
                <th>Features</th>
                <th className="whinself-column">
                  <img src="/@whinself_logo.png" alt="Whinself" className="robot-icon" />
                  Whinself
                </th>
                <th>
                  <span className="others-icon">☁️ 🔒</span> Others
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Number of accounts</td>
                <td className="whinself-column">No limits on accounts or servers!</td>
                <td>One account for $50/month</td>
              </tr>
              <tr>
                <td>Infrastructure</td>
                <td className="whinself-column">On-Premise - your server, your infrastructure!</td>
                <td>Your security depends on their cloud infrastructure</td>
              </tr>
              <tr>
                <td>Security</td>
                <td className="whinself-column">No data leaks!</td>
                <td>You have to give access to customers&apos; data - phone number, name, your messages</td>
              </tr>
              <tr>
                <td>Messages</td>
                <td className="whinself-column">No message limits!</td>
                <td>Some solutions have a price for messages, like $1 every 1,000 messages</td>
              </tr>
              <tr>
                <td>Hardware Requirements</td>
                <td className="whinself-column">Runs on any server, including Raspberry Pi!</td>
                <td>Not self-hosted - you must use their API server</td>
              </tr>
              <tr>
                <td>Trial Period</td>
                <td className="whinself-column">Extended trial period with all features included!</td>
                <td>Limited trial with restricted features</td>
              </tr>
              <tr>
                <td>Price</td>
                <td className="whinself-column">$2.5/month</td>
                <td>Monthly payment starts from $50</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="pricing-footer">
        <h3>Enterprise Solutions</h3>
        <p>Need a custom solution? We offer tailored plans for large organizations.</p>
        <a href="https://inutil-labs.com/#contact" target="_blank" rel="noopener noreferrer" className="enterprise-button">
          Contact Enterprise Sales
        </a>
      </div>
    </div>
  );
}

export default Pricing; 